import { __TEST__ } from "../constants";

const isTestEnvironment = () => {
  return process.env.NODE_ENV === __TEST__;
};

const commonUtils = {
  isTestEnvironment
};

export default commonUtils;
